import { ChangeDetectorRef, Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Actions, Select, Store } from '@ngxs/store';
import { Session } from 'src/app/interfaces/session-data';
import { Observable, Subject } from 'rxjs';
import { InitiateResponseCard } from 'src/app/interfaces/card/responses/InitiateResponseCard';
import { TransactionStatus } from 'src/app/interfaces/payment-option';
import { MapState } from '../shared/map.state';
import { BreakpointObserver } from '@angular/cdk/layout';
import { OverlayContainer } from '@angular/cdk/overlay';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { FileService } from 'src/app/services/file-service/file.service';
import { MobicredService } from 'src/app/services/mobicred/mobicred.service';
import { SecureEftService } from 'src/app/services/secure-eft/secure-eft.service';
import { SessionService } from 'src/app/services/session/session.service';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { SetSessionStorage } from '../shared/map.actions';

declare let gtag: Function;
declare let process: Function;
declare global {
  interface Window {
    hj: any;
  }
}

@Component({
  selector: 'app-channel-virtual',
  templateUrl: './channel-virtual.component.html',
  styleUrls: ['./channel-virtual.component.scss']
})
export class ChannelVirtualComponent implements OnInit {
  merchantTheme = {
    onedayonly: {
      themeName: 'one-day-only-theme'
    },
    neolife: {
      themeName: 'neolife-theme'
    }
  };

  @Select(MapState.sessionStorage) sessionStorage$: Observable<Session>;
  errorObject: any;

  public innerWidth: any;
  title = 'virtual';
  transactionAmount = '98.00';
  sessionToken = '';
  transactionStatus: TransactionStatus;
  mode: ProgressSpinnerMode = 'indeterminate';
  sessionDataRetrieved = false;
  color: ThemePalette = 'primary';
  diameter = 105;
  defaultBackgroundImg = `#f4f4f4`;
  backgroundImage = '';
  session: Session;
  loading = true;
  errResponse: any;
  closed;
  routeNavigatingTo;
  clearHeader;
  cleared = false;
  merchantDisplayInfo;
  mobile;
  waitForQueryParams = new Subject<string>();
  file: File;
  acsForm;
  initiateResponseCard: InitiateResponseCard;
  // on mobile height is flexible, but if the content doesn't fill then we have a problem, so use below var to set ngStyle height based on breakpoint observer
  @ViewChild('matCard') matCard: MatCard;
  // Custom Theme
  @HostBinding('class') componentCssClass;
  globifiedUrl: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private transactionService: TransactionService,
    private secureEftService: SecureEftService,
    private mobicredService: MobicredService,
    private sessionService: SessionService,
    private changeDetectorRef: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private actions$: Actions,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private store: Store,
    // private googleAnalyticsService: GoogleAnalyticsService,
    private fileService: FileService,
    private overlayContainer: OverlayContainer) {
      // console.log('=========================================== APP COMPONENT CONSTRUCTOR');
    this.waitForQueryParams.subscribe({
      next: valueToken => {
        if (valueToken === 'params') {
          this.route.queryParams.subscribe((data: { reference: string }) => {
            if (data.reference) {
              // this.login();
              this.sessionToken = data.reference;
              sessionStorage.setItem('sessionToken', this.sessionToken);
              this.login(true);
            }
          });
          this.route.queryParams.subscribe((data: { sessionToken: string }) => {
            if (data.sessionToken) {
              // this.login();
              this.sessionToken = data.sessionToken;
              sessionStorage.setItem('sessionToken', this.sessionToken);
              this.login(true);
            }
          });
        } else {
          this.sessionService.getSessionTokenWithNoSession(this.sessionToken)
            .subscribe({
              next: (value: Session) => {
                if (value) {
                  sessionStorage.setItem('sessionData', JSON.stringify(value));
                  this.configureRedirect(value);
                }
              },
              error: err => this.router.navigate(['transaction-status'])
            });
        }
      },
      error: err => this.router.navigate(['transaction-status'])
    });


    // set default theme
    // this.onSetTheme('default-theme');

    breakpointObserver.observe([
      // (max-width: 599.99px) and (orientation: portrait): false
      '(orientation: portrait)',
      '(max-width: 599.99px)'
    ]).subscribe(result => {
      this.mobile = result.matches;
    });

    this.globifiedUrl = this.router.url;
    this.routeNavigatingTo = window.location.host + this.router.url;
    gtag('config', 'UA-175892077-1', {
      page_path: this.router.url
    });
    if (this.router.url.indexOf('/error') > -1 || this.router.url.indexOf('/not-found') > -1 || this.router.url.indexOf('/transaction-status') > -1 || this.router.url.indexOf('/not-found') > -1 || this.router.url.indexOf('/not-found') > -1 || this.router.url.indexOf('/transaction-status') > -1) {
      // this.dontInitialiseVirtual = true;
      this.dontInitialiseVirtual(true);
      if (this.router.url.indexOf('/transaction-status') === -1 || this.router.url.indexOf('/transaction-status') === -1) {
        this.clearHeader = setInterval(() => {
          this.handleError();
          if (document.getElementsByTagName('app-header')[0]) {
            document.getElementsByTagName('app-header')[0].remove();
            clearInterval(this.clearHeader);
          } else {}
        }, 100);
      } else {

      }
    } else if (this.router.url.indexOf('/card/tds') > -1 || this.router.url.indexOf('/card/tds') > -1) {
      this.dontInitialiseVirtual(true);
    } else if (this.router.url.indexOf('/master_pass/this.routeridate') > -1) {
      this.dontInitialiseVirtual(true);
    } else if (this.router.url.indexOf('/switchpay/callback') > -1) {
      this.dontInitialiseVirtual(true);
    } else if (this.router.url.indexOf('/adumoeft/callback') > -1) {
      this.dontInitialiseVirtual(true);
    } else if (this.router.url.indexOf('/ozow/status') > -1) {
      this.dontInitialiseVirtual(true);
    } else {
      const queryParams = this.route.snapshot.queryParams;
      if(queryParams['token']){
        this.sessionToken = queryParams['token'];
        sessionStorage.setItem('sessionToken', this.sessionToken);
      } else {
        this.sessionToken = sessionStorage.getItem('sessionToken');
      }
      this.dontInitialiseVirtual(false);
    }
   }

    ngOnInit() {
      // console.log('=========================================== APP COMPONENT NGONINIT');
      sessionStorage.removeItem('selectedCard');
      if (sessionStorage.getItem('sessionData') && JSON.parse(sessionStorage.getItem('sessionData'))) {
        // console.log('Existing Session Data:', JSON.parse(sessionStorage.getItem('sessionData')));
        this.session = JSON.parse(sessionStorage.getItem('sessionData'));
        this.setUpTheme();
      } else {
        this.waitForQueryParams.next('params');
      }
      // Account for TDS
      // this.googleAnalyticsService.pageViewEvent('virtual.initialise.app.component', 'initialise');

      console.log(this.router.url);
      // this.dontInitialiseVirtual
      //   .subscribe(
      //     value => {
      //       console.log("value: ",value);
      //       if (!value) {
      //         this.login();
      //       } else {
      //         this.loading = false;
      //       }
      //       this.dontInitialiseVirtual.complete();
      //     }
      //   );
    }

    private dontInitialiseVirtual(value:boolean){
      console.log("value: ",value);
      if (!value) {
        this.login();
      } else {
        this.loading = false;
      }
    }

    handleError(err?: HttpErrorResponse) {
      if (!err) {
        this.errResponse = 'error';
      } else {
        this.errResponse = (err as HttpErrorResponse);
        // this.googleAnalyticsService.pageViewEvent('virtual.error.component', 'error');
        // this.googleAnalyticsService.eventEmitter('virtual.errors', 'error-handling', this.errResponse.error.message, 0);
        // this.router.navigate(['transaction-status']);
      }
      if (this.routeNavigatingTo.indexOf(window.location.host + '/error') > -1 || this.routeNavigatingTo.indexOf(window.location.host + '/virtual/error') > -1) {
        return;
      } else {
        if (!sessionStorage.getItem('sessionToken')) {
          this.router.navigate(['error'], { queryParams: { error: 'Oops something went wrong!', errorDescription: 'Invalid session, please return to the merchant and try again' } })
            .then(() => {
              this.loading = false;
            });
        } else {
          this.router.navigate(['transaction-status'])
            .then(() => {
              this.loading = false;
            });
        }
      }
    }

    login(redirectSession?: boolean) {
      // this.googleAnalyticsService.eventEmitter('virtual.initialise.app.component', 'virtual.login.attempt', 'attempt-login', 0, 'login');
      this.sessionService.login()
        .subscribe({
          error: err => this.handleError(err),
          next: value => {
            sessionStorage.setItem('authToken', value['access_token']);
            // this.googleAnalyticsService.eventEmitter('virtual.initialise.app.component', 'virtual.login.success', value['access_token'], 0);
            if (!redirectSession) {
              this.getSessionData();
            }
            this.waitForQueryParams.next('session');
          }
        });
    }

    getSessionData()  {
      // this.googleAnalyticsService.eventEmitter('virtual.initialise.app.component', 'virtual.get.sessiondata', this.sessionToken, 0);

      this.sessionService.getSessionData(this.sessionToken)
        .subscribe({
          next: data => this.configured(data),
          error: err => this.handleError(err)
        });
    }
    setUpTheme() {
      this.backgroundImage = `#f4f4f4`;
      if (this.session.sessionDisplayInformation.backgroundImageUrl && this.session.sessionDisplayInformation.backgroundImageUrl.length > 0) {
        this.backgroundImage = `url(${this.session.sessionDisplayInformation.backgroundImageUrl}) center`;
      }
      if (this.session.sessionDisplayInformation.label) {
        switch (this.session.sessionDisplayInformation.label.toLowerCase()) {
          case 'onedayonly': {
            this.onSetTheme(this.merchantTheme.onedayonly.themeName);
            if (document.getElementById('default-material-theme-mercury')) {
              document.getElementById('default-material-theme-mercury').remove();
            }
            break;
          }
          case 'neolife': {
            this.onSetTheme(this.merchantTheme.neolife.themeName);
            if (document.getElementById('default-material-theme-mercury')) {
              document.getElementById('default-material-theme-mercury').remove();
            }
            break;
          }
          default: {
            this.onSetTheme('default-theme');
          }
        }
      }
    }

    onSetTheme(theme) {
      // combine fn with above one at a later stage, combining 4 elements:
      // Background image, logo, colour and typography
      // colour:
      // if (document.getElementById('default-material-theme-mercury')) {
      //   document.getElementById('default-material-theme-mercury').remove();
      // }
      this.overlayContainer.getContainerElement().classList.add(theme);
      this.componentCssClass = theme;
    }

    configureEft() {
      // Add Secure Eft to index.html
      // JS:
      // const jqueryScript = document.createElement('script');
      // jqueryScript.src = 'https://code.jquery.com/jquery-1.12.4.min.js';
      // jqueryScript.id = 'callpay-secure_eft-jquery';
      const eftScript = document.createElement('script');
      eftScript.type = 'text/javascript';
      eftScript.src = 'https://eftsecure.callpay.com/js/eft-secure.min.js';
      eftScript.id = 'callpay-secure_eft-javascript-script';
      // Css:
      const eftCss = document.createElement('link');
      eftCss.type = 'text/css';
      eftCss.rel = 'stylesheet';
      eftCss.href = 'https://eftsecure.callpay.com/css/eftx.css';
      eftCss.id = 'callpay-secure_eft-link-el';
      // Append scripts to body and link to head
      // if (!document.getElementById('callpay-secure_eft-jquery')) {
      //   document.head.appendChild(jqueryScript);
      // }
      if (!document.getElementById('callpay-secure_eft-link-el')) {
        document.head.appendChild(eftCss);
      }
      if (!document.getElementById('callpay-secure_eft-javascript-script')) {
        document.head.appendChild(eftScript);
      }
    }

    configureRedirect(data) {
      this.session = data;
      // window.hj('tagRecording', [`Session Token: ${this.sessionToken}`, `Merchant Ref: ${this.session.sessionDisplayInformation.merchantReference}`, `Merchant Name: ${this.session.sessionDisplayInformation.label}`, `Amount: ${this.session.sessionDisplayInformation.amount}`, `Recipient: ${this.session.shippingDetails.recipient}`, `Redirect Route: ${this.globifiedUrl}`]);
      const eftEnabled = this.session.virtualConfiguration.paymentTypes.filter(value => value.code.toLowerCase() === 'eft');
      if (eftEnabled.length > 0) {
        this.configureEft();
      }
      // this.googleAnalyticsService.eventEmitter('virtual.initialise.app.component', 'virtual.sessiondata.retrieved', JSON.stringify(this.session), 0);
      this.setUpTheme();
      this.store.dispatch(new SetSessionStorage(this.session));
      this.loading = false;
    }

    configured(data) {
      this.session = data;
      // window.hj('tagRecording', [`Session Token: ${this.sessionToken}`, `Merchant Ref: ${this.session.sessionDisplayInformation.merchantReference}`, `Merchant Name: ${this.session.sessionDisplayInformation.label}`, `Amount: ${this.session.sessionDisplayInformation.amount}`, `Recipient: ${this.session.shippingDetails.recipient}`, `Virtual Route: ${this.session.virtualRoute}`]);
      const eftEnabled = this.session.virtualConfiguration.paymentTypes.filter(value => value.code.toLowerCase() === 'eft');
      if (eftEnabled.length > 0) {
        this.configureEft();
      }
      sessionStorage.setItem('sessionData', JSON.stringify(this.session));
      // this.googleAnalyticsService.eventEmitter('virtual.initialise.app.component', 'virtual.sessiondata.retrieved', JSON.stringify(this.session), 0);
      this.setUpTheme();
      // sessionStorage.setItem('theme', JSON.stringify(this.session.sessionDisplayInformation));

      // go to route
      this.store.dispatch(new SetSessionStorage(this.session));
      if (this.router.url.indexOf('/transaction-status') === -1 || this.router.url.indexOf('/error') === -1) {
        this.router.navigate([this.session.virtualRoute])
          .then(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }

    }
}
